
			if (import.meta.env.PROD) {
				var k = document.getElementsByTagName("head")[0];
				var c = document.createElement("script");
				c.async = true;
				c.type = "text/javascript";
				c.charset = "utf-8";
				c.setAttribute("crossorigin", "anonymous");
				c.src = "https://akashraj.tech/js/a.js";
				k.appendChild(c);
			}
			window.onload = (e) => {
				let loader = document.getElementById("loader");
				// this prevents capturing the fully loaded state when using react-snapshot to generate static pages
				// this will run if host is no localhost or if env is not prodution
				if (location.hostname !== "localhost" || !import.meta.env.PROD) {
					loader.classList.add("content-loaded");
				}
			};
		